import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateProjectMutation as _UpdateProjectMutation,
  UpdateProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const UpdateProjectMutation = graphql(`
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      reference
      description
      owner {
        id
      }
      pipeline {
        id
      }
      currentPipelineStage {
        id
      }
    }
  }
`);

const useUpdateProject = (
  options?: UseMutationOptions<
    _UpdateProjectMutation,
    unknown,
    UpdateProjectInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateProjectInput) => {
      return gqlClient.request(UpdateProjectMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.project(variables.projectId),
      });
    },
    ...options,
  });
};

export default useUpdateProject;
